/**
 * Replaces placeholders in a given text with corresponding values from an object.
 *
 * @param {Object} options - The options for replacing placeholders.
 * @param {string} options.text - The text containing placeholders to be replaced.
 * @param {object} options.data - An object containing key-value pairs for replacement.
 * @param {RegExp} [options.regex=/{(\w+)}/g] - The regular expression to match placeholders.
 * @return {string} The text with placeholders replaced by corresponding values.
 */
export const replacePlaceholders = ({
  text,
  data = {},
  regex = /{(\w+)}/g,
}) => {
  if (!text) return ''

  return text.replace(regex, (match, key) => {
    const value = data[key]

    return value !== undefined ? String(value) : match
  })
}
